import React from "react";
import $ from 'jquery';
import FushifaruLogo from "../../theme/images/background/fushifaru_main_logo.svg";
import FushifaruLoader from "../../theme/images/background/fushifaru_app_loader.jpg"
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { CMSPath } from "../../../config/constant";
import { setRegPage } from "../../../action/action";
import { locationSelectorWidget } from "../../../config/layout2constant";
import { setCurrentHomePage } from "../../action/homeAction";


export const CustomAfterLoaderScreen1 = (props) => {

    const { t } = props;
    let room = localStorage.getItem("room");

    const handlePrimaryButtonClick = () => {
        if(props.screenInfoAfterLoader.btnAction && props.screenInfoAfterLoader.btnAction.params && (props.screenInfoAfterLoader.btnAction.params.appPath == "login" || props.screenInfoAfterLoader.btnAction.params.appPath == "/login")){
            props.setRegPage(true)
            return;
        } 
        
        if(props.screenInfoAfterLoader.btnAction && props.screenInfoAfterLoader.btnAction.params && props.screenInfoAfterLoader.btnAction.params.appPath == "/selectHotel"){
            const isLocationTabThere = props.footerTabList.findIndex(tabList => locationSelectorWidget.some(el => el === tabList.uniqueKey.toLowerCase()));

            if(isLocationTabThere != -1){
                props.setCurrentHomePage(props.footerTabList[isLocationTabThere]);
                props.closeCustomScreenAfterLoader(true)
                return;
            }

        }
        
        if(props.screenInfoAfterLoader.btnAction && props.screenInfoAfterLoader.btnAction.params){
            props.handleRedirect(props.screenInfoAfterLoader.btnAction)
        }
    }

    let displaySize = window.screen.width * 2
    const [backgroundSize, setBackgroundSize] = React.useState(displaySize)
    const [foreground , setForeGround] = React.useState(false)

    React.useEffect(() => {

        if (backgroundSize > displaySize && !foreground) {
            setTimeout(() => {
                setBackgroundSize(backgroundSize - 0.6)
            },21)
        } else if (backgroundSize < (displaySize+300) && foreground){
            setTimeout(() => {
                setBackgroundSize(backgroundSize + 0.6)
            },21)
        }

        if( (backgroundSize <= displaySize && !foreground) || (backgroundSize >= (displaySize+300) && foreground) ){
            setForeGround(!foreground)
        }
    })

    React.useEffect(() => {
        if(window.StatusBar && window.device && window.device.platform == "iOS") window.StatusBar.overlaysWebView(true);

        $("body").addClass("overlay-cast");
        $(".customPreLoadButton1").attr('style', 'margin: 0 auto; background: none !important; box-shadow: none; border: 1px solid #fff; border-radius: 5px; color: #fff !important');

        return () => {
            if(window.StatusBar && window.device && window.device.platform == "iOS") window.StatusBar.overlaysWebView(false);
        }
    },[])

    return (
        <div>
            <section class="overlay">
                <div id="customPreloader1" class="overlay-window-container" style={{ background: `url(${ props.screenInfoAfterLoader.imageURI ? `${CMSPath}${props.screenInfoAfterLoader.imageURI}` : FushifaruLoader}) center center no-repeat`, backgroundSize: `${backgroundSize}px` }}>
                    <img src={`${CMSPath}${props.screenInfoAfterLoader.hotelLogo ? props.screenInfoAfterLoader.hotelLogo : props.logo}`} style={{ position: "fixed", top: "20%", margin: "0 auto", left: 0, right: 0, width: "8rem" }} />
                    <div style={{ position: "fixed", bottom: "3rem", width: "100%" }}>
                        { props.screenInfoAfterLoader.btnAction && (!room || room == "null") && <a onClick={handlePrimaryButtonClick} class="button primary w-90 all-caps customPreLoadButton1 margin-bottom-1">{t(`screenAfterLoader.primaryBtnText`)}</a>}
                        <button type="button" onClick={() => { props.closeCustomScreenAfterLoader(true) }} class="w-90 all-caps customPreLoadButton1">{t(`screenAfterLoader.welcome`)}</button>
                    </div>
                </div>
                <div class="splash-disc">{t(`screenAfterLoader.subText3`)}</div>
            </section>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        screenInfoAfterLoader: state.store.home.screenInfoAfterLoader,
        footerTabList: state.store.home.currentDuration && state.store.home.currentDuration.tabDetails.length > 0 ? state.store.home.currentDuration.tabDetails : [],
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    }
}

export default connect(mapStateToProps, {setRegPage, setCurrentHomePage})(withTranslation('translations')(CustomAfterLoaderScreen1));